<template>
    <div>
        <div v-for="(v, i) in list" :key="v.id">
            <deliverynameRecord :obj="v" @clickEditBtn="clickEditCallback" @clickDelBtn="clickDelCallback" />
        </div>
    </div>
</template>

<script setup>
    import {inject} from "vue";
    import deliverynameRecord from "@/components/shopopee/deliveryname/deliverynameRecord"

    const props = defineProps(["list"])
    const emits = defineEmits(["clickEditBtn", "clickDelBtn"])

    const i18n = inject("i18n")

    function clickEditCallback(obj) {
        emits("clickEditBtn", obj)
    }

    function clickDelCallback() {
        emits("clickDelBtn")
    }

</script>

<style scoped>

</style>